import { DefaultError, useMutation, useQuery } from '@tanstack/react-query';
import { useQueryToast } from 'hooks';
import i18next from 'i18next';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { IAssignSmartLink, ICreateSmartLink, ISmartLinkDomain } from './types';

export const useCreateSmartLink = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast('useCreateSmartLink');
  return useMutation<unknown, DefaultError, ICreateSmartLink>({
    mutationFn: async body => {
      loading(
        i18next.t('service-message.create.loading', {
          what: i18next.t('smartlink.what'),
        })
      );
      const response = await apiClient({
        method: 'PUT',
        url: 'Smartlink/Create',
        body,
      });

      return responseHandler(response, {
        groupName: 'useCreateSmartLink',
      });
    },
    onSuccess: data => {
      success(
        i18next.t('service-message.create.success', {
          what: i18next.t('smartlink.what'),
        })
      );
    },
    onError: dismiss,
  });
};
export const useAssignSmartLink = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast('useAssignSmartLink');
  return useMutation<unknown, DefaultError, IAssignSmartLink>({
    mutationFn: async body => {
      loading(
        i18next.t('service-message.create.loading', {
          what: i18next.t('smartlink.what'),
        })
      );
      const response = await apiClient({
        method: 'PUT',
        url: 'Smartlink/Assign',
        body,
      });

      return responseHandler(response, {
        groupName: 'useAssignSmartLink',
      });
    },
    onSuccess: data => {
      success(
        i18next.t('service-message.create.success', {
          what: i18next.t('smartlink.what'),
        })
      );
    },
    onError: dismiss,
  });
};

export const useGetSmartLinkDomains = () => {
  const { responseHandler } = useResponseHandler();
  return useQuery<ISmartLinkDomain[], DefaultError>({
    queryKey: ['smartlink-domains'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: 'Smartlink/AssignedDomains',
      });

      return responseHandler(response, {
        groupName: `useGetSmartLinkDomains`,
      });
    },
  });
};
